import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-9f27efd493/icons'
import { Tooltip } from 'antd';
import { COLOURS } from '../../colours';

export default function Icon({ 
  name, primary, primaryOpacity, secondary, secondaryOpacity, 
  pr, pb, size, alt, swap, onClick, style, spin, rotate, 
  className, brand, kit, inverse = false
}) {
  let icon = brand ? byPrefixAndName.fab[name] : kit ? byPrefixAndName.fak[name] : byPrefixAndName.fad[name]
  return ( 
    <Tooltip title={alt} color={ COLOURS.PRIMARY }>
      <FontAwesomeIcon 
        fixedWidth
        inverse={inverse}
        pulse={spin}
        alt={alt}
        style={{ 
          '--fa-primary-color': primary || COLOURS.PRIMARY,
          '--fa-primary-opacity': primaryOpacity || '1',
          '--fa-secondary-color': secondary || COLOURS.BLACK,
          '--fa-secondary-opacity': secondaryOpacity || '0.4',
          'paddingRight': pr || '0px',
          'paddingBottom': pb || '0px',
          'fontSize' : size || '14px',
          'cursor' : onClick != null ? 'pointer' : '', 
          ...style
        }}
        color={ kit ? primary : null }
        className={className}
        icon={icon}
        swapOpacity={swap}
        rotation={ rotate ? rotate : 0 }
        onClick={onClick}/>
      </Tooltip>
  )
}